import { IntelliZoneQuery, IntelliZoneRoutes } from './intellizone.types';
import { InProductTrialTypeEnum } from '@nirvana/shared/dtos/types/in-product-trials';
import { GzDialogWebComponent } from '../../../ui/gzDialog';
import { WEB_COMPONENT_GZ_DIALOG } from '../../../webcomponents.constants';
import { NavigationHelper } from '@nirvana/shared/navigation';

/**
 * Computes URL for TI Portal - Cumulative Search
 * Reference: https://bitdefender.atlassian.net/wiki/spaces/THIP/pages/1871085943/TI+Portal+-+Cumulative+Search+with+shareable+links
 * @param {string} host - IntelliZone HOST
 * @param {IntelliZoneQuery} query - Query object with filter key and value
 * @returns string - {HOST}/threat-search/cumulative-browse?query={encodedQuery}
 */
function constructIntelliZoneCumulativeSearchQuery(host: string, query: IntelliZoneQuery): string {
  // remove last '/' if found
  const intelliZoneHost = host.charAt(host.length - 1) === '/'
    ? host.slice(0, -1)
    : host;
  return intelliZoneHost + IntelliZoneRoutes.THREAT_SEARCH +
    encodeURIComponent(
      Object.entries(query).reduce((result, [filter, value]) => {
        const parsedValue = value
          ? typeof value === 'number'
            ? value.toString()
            : `"${value}"`
          : undefined;

        return parsedValue !== undefined
          ? `${result === '' ? '' : result + ' AND '}${filter}: ${parsedValue}`
          : result;
      }, '')
    );
}

/**
 * Opens a new window with a specified url
 * @param url
 */
function pivotToIntelliZone(url: string): void {
  window.open(url);
}

/**
 * Pivot to IntelliZone platform on Cumulative Search view
 * @param {string} host
 * @param {IntelliZoneQuery} query
 */
export function pivotToCumulativeSearchIntelliZone(host: string, query: IntelliZoneQuery): void {
  const url = constructIntelliZoneCumulativeSearchQuery(host, query);
  pivotToIntelliZone(url);
}

/**
 * Pivot to In Product Trials Hub - Threat Intelligence (IntelliZone) view
 */
export function pivotToInProductTrialsIntelliZone(): void {
  // If there are multiple dialogs in dom, we must close them in order to see In Product Trials view
  const windowDialogs: NodeListOf<GzDialogWebComponent> = document.body.querySelectorAll(
    WEB_COMPONENT_GZ_DIALOG + '[isWindow]'
  ) as NodeListOf<GzDialogWebComponent>;

  for (const dialog of Array.from(windowDialogs)) {
    dialog.dismiss();
  }

  // Navigate to product trials page
  NavigationHelper.navigateToProductsHub(InProductTrialTypeEnum.ThreatIntel);
}
